import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/delete.svg'


const _hoisted_1 = { class: "icon" }
const _hoisted_2 = {
  key: 0,
  class: "icon_delete",
  src: _imports_0
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "cancel-confirm-selector",
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(['cancel-confirm-button', { disabled: _ctx.disabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onclick && _ctx.onclick(...args)))
    }, [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass({
            icon_x: _ctx.mode === 'x',
            icon_o: _ctx.mode === 'o',
          })
        }, [
          (_ctx.mode === 'delete')
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true),
          _hoisted_3,
          _hoisted_4
        ], 2)
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
    ], 2)
  ], 4))
}